(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_urgency-announcement"] && !Shopify.designMode) return;
  try {
    class UrgencyCountdown extends HTMLElement {
  connectedCallback() {
    this._timeEl = this.querySelector('.urgency-countdown__time');
    if (!this._timeEl) return;
    this._timer = null;
    this._onVisibility = this._handleVisibility.bind(this);
    document.addEventListener('visibilitychange', this._onVisibility);
    this._readSettings();
    this._tick();
  }

  disconnectedCallback() {
    clearTimeout(this._timer);
    if (this._onVisibility) {
      document.removeEventListener('visibilitychange', this._onVisibility);
    }
  }

  _readSettings() {
    this._modo = this.dataset.modo || 'daily';
    this._hora = parseInt(this.dataset.hora) || 0;
    this._minuto = parseInt(this.dataset.minuto) || 0;
    this._fecha = this.dataset.fecha || '';
    this._zona = this.dataset.zona || 'Europe/Lisbon';
    this._alTerminar = this.dataset.alTerminar || 'hide';
    this._segundos = this.dataset.segundos !== 'false';
    this._dias = this.dataset.dias === 'true';
    this._target = this._calcTarget();
  }

  _getParts(date, zone) {
    const parts = new Intl.DateTimeFormat('en-US', {
      timeZone: zone,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
    }).formatToParts(date);
    const get = (t) => parseInt(parts.find((p) => p.type === t).value);
    return {
      year: get('year'),
      month: get('month'),
      day: get('day'),
      hour: get('hour') % 24,
      minute: get('minute'),
      second: get('second')
    };
  }

  _localToUTC(year, month, day, hour, minute, zone) {
    const guess = new Date(Date.UTC(year, month - 1, day, hour, minute));
    const p = this._getParts(guess, zone);
    const localMins = p.hour * 60 + p.minute;
    const targetMins = hour * 60 + minute;
    let diffMins = targetMins - localMins;
    if (diffMins > 720) diffMins -= 1440;
    if (diffMins < -720) diffMins += 1440;
    return new Date(guess.getTime() + diffMins * 60000);
  }

  _calcDaily(now) {
    const p = this._getParts(now, this._zona);
    let t = this._localToUTC(p.year, p.month, p.day, this._hora, this._minuto, this._zona);
    if (t <= now) {
      const tomorrow = new Date(now.getTime() + 86400000);
      const tp = this._getParts(tomorrow, this._zona);
      t = this._localToUTC(tp.year, tp.month, tp.day, this._hora, this._minuto, this._zona);
    }
    return t;
  }

  _calcTarget() {
    const now = new Date();
    if (this._modo !== 'fixed') return this._calcDaily(now);
    const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(this._fecha);
    if (!m) return this._calcDaily(now);
    const y = parseInt(m[1]);
    const mo = parseInt(m[2]);
    const d = parseInt(m[3]);
    if (mo < 1 || mo > 12 || d < 1 || d > 31) return this._calcDaily(now);
    const t = this._localToUTC(y, mo, d, this._hora, this._minuto, this._zona);
    if (isNaN(t.getTime())) return this._calcDaily(now);
    if (t <= now) {
      return this._alTerminar === 'daily' ? this._calcDaily(now) : null;
    }
    return t;
  }

  _pad(n) {
    return String(n).padStart(2, '0');
  }

  _tick() {
    if (!this._target) {
      const slide = this.closest('.announcement-bar__slide');
      if (slide) slide.style.display = 'none';
      return;
    }
    const remaining = Math.max(0, this._target - Date.now());
    if (remaining === 0) {
      this._readSettings();
      this._tick();
      return;
    }
    const totalSecs = Math.floor(remaining / 1000);
    const days = Math.floor(totalSecs / 86400);
    const hours = Math.floor((totalSecs % 86400) / 3600);
    const mins = Math.floor((totalSecs % 3600) / 60);
    const secs = totalSecs % 60;
    let text;
    if (this._dias && days > 0) {
      text = this._segundos
        ? `${days}d ${this._pad(hours)}:${this._pad(mins)}:${this._pad(secs)}`
        : `${days}d ${this._pad(hours)}:${this._pad(mins)}`;
    } else {
      text = this._segundos
        ? `${this._pad(hours)}:${this._pad(mins)}:${this._pad(secs)}`
        : `${this._pad(hours)}:${this._pad(mins)}`;
    }
    this._timeEl.textContent = text;
    this._timeEl.removeAttribute('hidden');
    this._timer = setTimeout(() => this._tick(), 1000);
  }

  _handleVisibility() {
    if (document.hidden) {
      clearTimeout(this._timer);
    } else {
      this._readSettings();
      this._tick();
    }
  }
}

if (!customElements.get('urgency-countdown')) {
  customElements.define('urgency-countdown', UrgencyCountdown);
}

if (window.Shopify && window.Shopify.designMode) {
  const _ucHandleEditorEvent = (e) => {
    e.target.querySelectorAll('urgency-countdown').forEach((el) => {
      clearTimeout(el._timer);
      if (el._readSettings) {
        el._readSettings();
        el._tick();
      }
    });
  };
  document.addEventListener('shopify:section:load', _ucHandleEditorEvent);
  document.addEventListener('shopify:section:select', _ucHandleEditorEvent);
}
  } catch(e) { console.error(e); }
})();

})();
